import LocationHead from '../components/location/LocationHead';
import LocationContent from '../components/location/LocationContent';

export default function Location() {
  return (
    <>
      <LocationHead />
      <LocationContent />
    </>
  );
}